<template>
    <div>
        <ul v-if="mediaLists.length > 0">
            <li class="form-label">{{ $t('Media List') }}</li>
            <li>
                <cic-select
                    id="route_media_list"
                    :enabled="editing"
                    :options="mediaLists.map((x) => ({ value: x.mediaListId, label: x.name }))"
                    :placeholder="$t('Select media list...')"
                    :value="route.mediaListId > 0 ? route.mediaListId : null"
                    clearable
                    @input="(val) => updateFieldValue('mediaListId', val)"
                />
            </li>
            <li v-if="warning">
                {{ $t('* Selected media list is restricted') }}
            </li>
            <template v-if="route.mediaListId > 0">
                <li class="form-label inline-form-item">
                    <span>{{ $t('Whisper Prompt') }}</span>
                    <icon-button icon="help-icon" :title="$t('DESC_ACTIVATE_WHISPER')" />
                </li>
                <li class="inline-form-item">
                    <cic-checkbox
                        id="route_whisper"
                        :enabled="editing"
                        :value="route.whisperPromptId !== null && route.whisperPromptId !== undefined"
                        @input="(val) => updateFieldValue('whisperPromptId', val ? 0 : null)"
                    />
                    <cic-select
                        v-if="route.whisperPromptId !== null && route.whisperPromptId !== undefined"
                        id="route_whisper_prompt"
                        :enabled="editing && !warning"
                        :options="prompts.map((x) => ({ value: x.id, label: x.name }))"
                        :placeholder="$t('Please select...')"
                        :value="route.whisperPromptId > 0 ? route.whisperPromptId : null"
                        @input="(val) => updateFieldValue('whisperPromptId', val)"
                    />
                </li>
                <template v-if="route.type === 1">
                    <li class="form-label">{{ $t('Hold Prompt') }}</li>
                    <li class="inline-form-item">
                        <cic-checkbox
                            id="route_hold"
                            :enabled="editing"
                            :value="route.holdPromptId !== null && route.holdPromptId !== undefined"
                            @input="(val) => updateFieldValue('holdPromptId', val ? 0 : null)"
                        />
                        <cic-select
                            v-if="route.holdPromptId !== null && route.holdPromptId !== undefined"
                            id="route_hold_prompt"
                            :enabled="editing && !warning"
                            :options="prompts.map((x) => ({ value: x.id, label: x.name }))"
                            :placeholder="$t('Please select...')"
                            :value="route.holdPromptId > 0 ? route.holdPromptId : null"
                            @input="(val) => updateFieldValue('holdPromptId', val)"
                        />
                    </li>
                    <li class="form-label">{{ $t('Call Failure Prompt') }}</li>
                    <li class="inline-form-item">
                        <cic-checkbox
                            id="route_fail"
                            :enabled="editing"
                            :value="route.failurePromptId !== null && route.failurePromptId !== undefined"
                            @input="(val) => updateFieldValue('failurePromptId', val ? 0 : null)"
                        />
                        <cic-select
                            v-if="route.failurePromptId !== null && route.failurePromptId !== undefined"
                            id="route_fail_prompt"
                            :enabled="editing && !warning"
                            :options="prompts.map((x) => ({ value: x.id, label: x.name }))"
                            :placeholder="$t('Please select...')"
                            :value="route.failurePromptId > 0 ? route.failurePromptId : null"
                            @input="(val) => updateFieldValue('failurePromptId', val)"
                        />
                    </li>
                </template>
            </template>
        </ul>
        <ul v-if="$store.routeData.canRecord">
            <li class="form-label inline-form-item">
                <span>{{ $t('Recording') }}</span>
                <icon-button icon="help-icon" :title="$t('DESC_ACTIVATE_RECORDING')" />
            </li>
            <li>
                <cic-checkbox
                    id="route_record"
                    :enabled="editing"
                    :value="route.record"
                    @input="(val) => updateFieldValue('record', val)"
                />
            </li>
        </ul>
        <ul v-if="(route.type === 1 || sipVoicemail) && voicemailProfiles.length > 0">
            <li class="form-label inline-form-item">
                <span>{{ $t('VOICEMAIL_PROFILE') }}</span>
                <icon-button icon="help-icon" :title="$t('DESC_ACTIVATE_VOICEMAIL')" />
            </li>
            <li class="inline-form-item">
                <cic-checkbox
                    id="route_voicemail"
                    :enabled="editing"
                    :value="route.mailboxId !== null && route.mailboxId !== undefined"
                    @input="(val) => updateFieldValue('mailboxId', val ? 0 : null)"
                />
                <cic-select
                    v-if="route.mailboxId !== null && route.mailboxId !== undefined"
                    id="route_voicemail_profile"
                    :enabled="editing"
                    :options="voicemailProfiles.map((x) => ({ value: x.mailboxId, label: x.name }))"
                    :placeholder="$t('Select Profile...')"
                    :value="route.mailboxId !== 0 ? route.mailboxId : null"
                    @input="(val) => updateFieldValue('mailboxId', val)"
                />
            </li>
        </ul>
        <ul v-if="route.type === 1 && $store.hasRight('QUEUE_ONWARD_ROUTE')">
            <li class="form-label">
                {{ $t('Queuing') }}
            </li>
            <li>
                <cic-checkbox
                    id="route_queue"
                    :enabled="editing"
                    :value="route.queue"
                    @input="(val) => updateFieldValue('queue', val)"
                />
            </li>
            <template v-if="route.queue">
                <li class="form-label">
                    {{ $t('Unlimited Maximum Queuing Time') }}
                </li>
                <li>
                    <cic-checkbox
                        id="route_queue_unlimited"
                        :enabled="editing"
                        :value="route.maxQueueTime === -1"
                        @input="(val) => updateFieldValue('maxQueueTime', val ? -1 : 0)"
                    />
                </li>
                <template v-if="route.maxQueueTime !== -1">
                    <li class="form-label">
                        {{ $t('Maximum Queuing Time (secs)') }}
                    </li>
                    <li>
                        <cic-textbox
                            id="route_queue_time"
                            :enabled="editing"
                            :int-only="true"
                            :value="route.maxQueueTime"
                            @input="(val) => updateFieldValue('maxQueueTime', val)"
                        />
                    </li>
                </template>
            </template>
        </ul>
    </div>
</template>

<script>
    import IconButton from '@/components/controls/IconButton';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import CicSelect from '@/components/inputs/CicSelect';
    import CicTextbox from '@/components/inputs/CicTextbox';

    export default {
        name: 'VoiceOptions',
        components: {
            CicCheckbox,
            CicSelect,
            CicTextbox,
            IconButton,
        },
        props: {
            editing: {
                type: Boolean,
                default: false,
            },
            route: {
                type: Object,
                required: true,
            },
            mediaLists: {
                type: Array,
                required: true,
            },
            sipVoicemail: {
                type: Boolean,
                default: false,
            },
            voicemailProfiles: {
                type: Array,
                required: true,
            },
        },
        emits: ['change'],
        computed: {
            prompts() {
                const list = this.mediaLists.find((x) => x.mediaListId === this.route.mediaListId);
                return list?.prompts ?? [];
            },
            warning() {
                return (
                    this.route.mediaListId &&
                    this.mediaLists.some((x) => x.mediaListId === this.route.mediaListId && !x.allowed)
                );
            },
        },
        methods: {
            updateFieldValue(field, val) {
                this.$emit('change', field, val);
            },
        },
    };
</script>
